import {h} from 'preact';

export function AutomatchRealtors({suggestedRealtors}) {
    return (
        <div className="realtor-card-list">
            <h3>Automatch Results</h3>
            {!(suggestedRealtors || []).length && (
                <div className="col-xs-12 realtor-card text-center">No Automatch Realtors found for this request</div>
            )}
            {(suggestedRealtors || []).map(r => (
                <div className={`col-xs-12 realtor-card ${r.colorCode}`}>
                    <div className="realtor-profile">
                        <a
                            className="realtor-avatar"
                            href={`/re/listRealtor?realtorId=${r.realtorId}`}
                            target="_blank"
                            style="margin-right: 10px">
                            <img
                                className="results-box-portrait"
                                alt={r.name}
                                src={r.filteredPhoto}
                                onerror={() => replaceImageOnError(this, 'img/profile-icon-l.jpg')}
                                title={r.name}
                            />
                        </a>
                        <div className="realtor-name-wrapper">
                            <a className="realtor-name" href={`/re/listRealtor?realtorId=${r.realtorId}`} target="_blank">{r.name}</a>
                            <div className="realtor-socials">
                                {r.zillowUrl && (
                                    <span className="social-icon">
                                        <a rel="nofollow" href={r.zillowUrl} target="_blank">
                                            <i className="fa-zillow-square"></i>
                                        </a>
                                    </span>
                                )}
                                {r.linkedInUrl && (
                                    <span className="social-icon">
                                        <a target="_blank" href={r.linkedInUrl} rel="nofollow">
                                            <i className="fa fa-linkedin-square" aria-hidden="true"></i>
                                        </a>
                                    </span>
                                )}
                            </div>
                            <div className="realtor-brokerage">{r.brokerage}</div>
                        </div>
                    </div>
                    <div className="realtor-details">
                        {r.topAgent && <span className="bubbletip luxury">LUXURY AGENT</span>}
                        {r.immediateProposal === 2 ||
                            (r.immediateProposal === 4 && (
                                <span className="bubbletip imd">
                                    <i className="fa fa-bolt"></i> IMD
                                </span>
                            ))}
                        {!r.sellerPctMin && (
                            <span className="bubbletip commission" title="Commission Style: Unknown">
                                $?
                            </span>
                        )}
                        {r.sellerPctMin < 2 && (
                            <span className="bubbletip commission" title="Commission Style: < 2%">
                                $
                            </span>
                        )}
                        {r.sellerPctMin >= 2 && r.sellerPctMin < 2.5 && (
                            <span className="bubbletip commission" title="Commission Style: 2% - 2.49%">
                                $$
                            </span>
                        )}
                        {r.sellerPctMin >= 2.5 && (
                            <span className="bubbletip commission" title="Commission Style: >= 2.5">
                                $$$
                            </span>
                        )}
                        <div className="realtor-proposal-details pull-right" alt="Client messaged agent">
                            {r.ownMessageAndPhoneForSpecificRequest && (
                                <span className="bubbletip action">
                                    <i className="icon-comment-outline"/>
                                </span>
                            )}
                            {r.viewProposalForSpecificRequest && (
                                <span className="bubbletip action" alt="Client viewed proposal">
                                    <i className="icon-eye-filled"/>
                                </span>
                            )}
                            {r.ownMessageAndPhoneForSpecificRequest && (
                                <span className="bubbletip action" alt="Client called agent">
                                    <i className="icon-phone-calling-4"/>
                                </span>
                            )}
                            {r.clientCallPinStatus && (
                                <span className={"bubbletip action " + ({CLAIMED: 'green', EXPIRED: 'gray'}[r.clientCallPinStatus] || '')} alt="Client called agent">
                                    <i className="icon-phone-calling-4"/>
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="realtor-statistics">
                        <span className="stat">
                            <b className="text-blue">{r.inviteCount} </b>
                            Invites
                        </span>{' '}
                        <span className="stat">
                            <b className="text-blue">{Math.round((r.bidCount / r.inviteCount) * 100)}% </b>
                            Bid
                        </span>
                        <span className="stat">
                            <b className="text-blue">{Math.round((r.finalCount / r.inviteCount) * 100)}% </b>
                            Final
                        </span>
                        <span className="stat">
                            <b className="text-blue">{Math.round((r.winCount / r.inviteCount) * 100)}% </b>
                            Win
                        </span>
                    </div>
                    <div>
                        <strong style="font-size: 14px">{r.fetchGroup}</strong>
                    </div>
                </div>
            ))}
        </div>
    );
}
